import { render, staticRenderFns } from "./ListPc.vue?vue&type=template&id=f6ce07fe&scoped=true"
import script from "./ListPc.vue?vue&type=script&lang=ts"
export * from "./ListPc.vue?vue&type=script&lang=ts"
import style0 from "./ListPc.vue?vue&type=style&index=0&id=f6ce07fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ce07fe",
  null
  
)

export default component.exports